export function mapProfilesToOptions(profiles) {
  return profiles?.length
    ? profiles.map((profile) => ({
      label: profile.name,
      value: profile.id
    }))
    : [];
}

export function getSelectedProfiles(selectedProfiles, profilesOptions) {
  return selectedProfiles?.length && profilesOptions?.length
    ? profilesOptions.filter((profile) =>
      selectedProfiles.find(
        (selectedProfile) => selectedProfile.id === profile.value
      )
    )
    : null;
}

export function getDefaultProfile(defaultProfileId, profilesOptions) {
  return defaultProfileId
    ? profilesOptions?.find((p) => p.value === defaultProfileId)
    : null;
}

export function getDefaultDateRange(defaultDateRange, dateRangesOptions) {
  return defaultDateRange
    ? dateRangesOptions?.find((d) => d.value === defaultDateRange)
    : null;
}
